import * as React from "react";
import {
  Grid,
  AppBar,
  Toolbar,
  Menu,
  MenuItem,
  ListItemIcon,
  Box,
  Typography,
  Divider,
  Breadcrumbs,
  Link
} from "@mui/material";
import IBlogo from "../../Assets/ib_color.png";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import AgentImg from "../../Assets/agent.png";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import GlobalPopUp from "../global/globalPopUp/GLobalPopUp";
import { DashboardInfoContext, DashboardInfoPayload } from "../../Context/dashboardContext";
import { UserContext, UserPayload } from "../../Context/userContext";
import { HeaderStyles } from './headerStyles'
import { useNavigate, useSearchParams } from "react-router-dom";
import authService from "../../utils/authService";
import { GetTimeZone } from "../../utils/getTimezoneOffset";

interface HeaderProps {
  showLogo: Boolean;
  showEnv: Boolean;
  PortalName?: string;
  EnvName?: string;
  height: string;
  width: string;
}

const mapActiveSectionToPortalName = {
  threepscodes: "3PS Codes",
}

function Header(props: HeaderProps) {
  const { classes } = HeaderStyles();
  const { headerRightBox, timeZoneBox, headerMainContainer,breadCrumbsTextStyles } = classes;
  const {
    setUserDetail,
    userDetail,
    activeComponent,
    logout
  } = React.useContext(UserContext) as UserPayload;
  const {
    applicantFullName,
    agentFullName,
  } = React.useContext(DashboardInfoContext) as DashboardInfoPayload;
  const [openMenu, setOpenMenu] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showChangeEnvironmentPopUp, setShowChangeEnvironmentPopUp] = React.useState(false);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpenMenu(false);
  };

  const openDialogBoxHandler = () => { setShowChangeEnvironmentPopUp(true) };


  const HandleNavigation = (section: string) => {
    //   Check the current section contains settings
    if (section === "settings") {
      //   Navigate to the settings page
      return;
    }
    //   Navigate to the section
    navigate(`/${section}`);
  }

  const breadcrumbSections = [
    <Link key="1" color="inherit" onClick={()=>{HandleNavigation(activeComponent.activeSection)}} className={breadCrumbsTextStyles}>
      {mapActiveSectionToPortalName[activeComponent.activeSection as keyof typeof mapActiveSectionToPortalName] ?? activeComponent.activeSection.charAt(0).toUpperCase() + activeComponent.activeSection.slice(1)}
    </Link>,
  ];

  const flagHasOpId = searchParams.has("opportunityId");
  const flagHasUserId = searchParams.has("userId");

  const shouldShowInsightsDetailBreadcrumb =
      applicantFullName !== null &&
      activeComponent.activeSection === "insights" &&
      flagHasOpId;

  const shouldShowAgentDetailBreadcrumb =
      agentFullName !== null &&
      activeComponent.activeSection === "agents" &&
      flagHasUserId;

  return (
    <React.Fragment>
      <GlobalPopUp
        flagPopUp={showChangeEnvironmentPopUp}
        setflagPopUp={setShowChangeEnvironmentPopUp}
        heading="Change Environment"
        message="hello"
        section="changeEnvironment"
      />
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={openMenu}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem>
          <Typography sx={{ fontSize: "15px", fontWeight: "600" }}>
            {userDetail?.value?.emailId}
          </Typography>
          <Divider />
        </MenuItem>
        <MenuItem onClick={openDialogBoxHandler}>
          <ListItemIcon>
            <ManageAccountsIcon fontSize="small" />
          </ListItemIcon>
          Environment
        </MenuItem>
        <MenuItem onClick={logout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
      <Grid item sx={{ height: props.height }}>
        <AppBar
          sx={{
            width: props.width,
            height: props.height,
            background: "#FFFFFF",
            boxShadow: "none !important",
            zIndex: 1,
            // borderBottom: props.showEnv ? "" : "1px solid #D9D9D9 !important",
          }}
        >
          <Toolbar className={classes.toolBarCtn}>
            <Grid className={headerMainContainer} container>
              {props.showEnv && (
                <>
                  <Breadcrumbs separator="›" aria-label="breadcrumb">
                    {breadcrumbSections}
                    {shouldShowInsightsDetailBreadcrumb && (
                        <Typography key="2" sx={{ color: "text.primary" }}>
                          {`${applicantFullName}'s View`}
                        </Typography>
                    )}
                    {shouldShowAgentDetailBreadcrumb && (
                        <Typography key="3" sx={{ color: "text.primary" }}>
                          {`${agentFullName}'s View`}
                        </Typography>
                    )}
                  </Breadcrumbs>
                </>
              )}
              {props.showLogo && (
                <img style={{ width: "150px", height: "34px" }} src={IBlogo} />
              )}
              {props.showEnv && (
                <Box className={headerRightBox}>
                  <Box sx={{ marginRight: "10px" }}>
                    <div className={timeZoneBox}>
                      {GetTimeZone()}
                    </div>
                  </Box>
                  <Box>
                    <img
                      alt="Agent profile"
                      src={AgentImg}
                      style={{ width: "28px", height: "28px" }}
                    />
                    <KeyboardArrowDownRoundedIcon
                      onClick={handleClick}
                      aria-controls={openMenu ? "account-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={openMenu ? "true" : undefined}
                      sx={{ color: "#1D1D1D", cursor: "pointer" }}
                    />
                  </Box>
                </Box>
              )}
            </Grid>
          </Toolbar>
        </AppBar>
      </Grid>
    </React.Fragment>
  );
}
export default Header;
